import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=c959aa7e&"
import script from "./footer.vue?vue&type=script&lang=ts&"
export * from "./footer.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/scss/spacer.scss?vue&type=style&index=0&lang=scss&module=styleSpacer&"
import style1 from "../../assets/scss/grid.scss?vue&type=style&index=1&lang=scss&module=styleGrid&"
import style2 from "../../assets/scss/mobile/grid.scss?vue&type=style&index=2&lang=scss&module=styleGridMobile&"
import style3 from "./footer.vue?vue&type=style&index=3&lang=scss&module=true&"




function injectStyles (context) {
  
  this["styleSpacer"] = (style0.locals || style0)
this["styleGrid"] = (style1.locals || style1)
this["styleGridMobile"] = (style2.locals || style2)
this["$style"] = (style3.locals || style3)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('/var/www/www/frontend/components/footer/footer.vue').default})
